import { Component, Input, TemplateRef, Inject, ComponentFactoryResolver } from '@angular/core';
import { CP_DIALOG_DATA } from '../dialog/dialog.service';
import { CpDialogRef } from '../dialog/dialog.ref';

export type CPGenericModalData = {
  title?: string;
  subTitle?: string;
  headerTemplate?: TemplateRef<void>;
  contentTemplate?: TemplateRef<void>;
  confirmText?: string;
  cancelText?: string;
};
export type CPGenericModalResult = {
  event: Event;
  trigger: 'CONFIRM' | 'CANCEL' | 'DELETE';
  data?;
};

@Component({
  selector: 'cp-generic-modal',
  templateUrl: './cp-generic-modal.component.html',
})
export class CPGenericModalComponent {
  @Input() title: string;
  @Input() subTitle: string;

  @Input() headerTemplate: TemplateRef<void>;
  @Input() contentTemplate: TemplateRef<void>;

  @Input() confirmText = 'Confirm';
  @Input() cancelText = 'Cancel'; //Button will be hidden with falsy value
  @Input() showCTA = true;
  @Input() buttonLinkHref: string;
  confirmEnabled: boolean = true;

  // @Output('confirm') customConfirm = new EventEmitter<Event>();
  // @Output('cancel') customCancel = new EventEmitter<Event>();

  constructor(
    @Inject(CP_DIALOG_DATA) protected data: CPGenericModalData,
    protected dialogRef: CpDialogRef<CPGenericModalComponent, CPGenericModalResult>,
    protected componentFactoryResolver: ComponentFactoryResolver
  ) {}

  ngOnInit() {
    if (this.data) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(CPGenericModalComponent);
      const childInstance = this;
      const configData = this.data;

      componentFactory.inputs.forEach((input) => {
        if (input.templateName in configData) {
          childInstance[input.propName] = configData[input.templateName];
        }
      });
    }
  }

  confirm(ev: Event) {
    if (!this.confirmEnabled) {
      return;
    }

    this.dialogRef.close({ event: ev, trigger: 'CONFIRM' });
  }
  cancel(ev: Event) {
    this.dialogRef.close({ event: ev, trigger: 'CANCEL' });
  }

  navigate() {
    window.open(this.buttonLinkHref, '_blank');
  }

  isConfirmEnabled(value: boolean) {
    this.confirmEnabled = value;
  }
}
